/**
 * SOLO FADE (solo_fade) — the house covers the player's bet. A brief cosmetic
 * beat between placing the bet and throwing: the wallet slides away (betting is
 * done) while the camera holds on the table, and a banner announces the house
 * is fading the bet. The short server timer then advances to ROLL.
 */

import type { GameUpdate } from '@sdl/shared';
import { State } from '../State.js';

export class SoloFadeState extends State {
  async onEnter(update: GameUpdate): Promise<void> {
    const game = this.game;

    game.playerProfilesOverlay?.show();
    game.playerProfilesOverlay?.setMode('betting');
    game.bettingHUD3D?.setLockInVisible(false);
    game.countdownOverlay?.stop();

    // Bet is placed → close the wallet but stay at the betting anchor while the
    // house covers the bet.
    await game.enterBettingMode({
      open: false,
      animated: update.animated,
      previousState: update.previousState,
    });

    game.instructionBanner?.show(
      { title: 'The House Fades You', text: 'Covering your bet...' },
      update.animated,
    );

    this._updateProfiles(update);
    await this._checkPlayers(update);
  }

  async onUpdate(update: GameUpdate): Promise<void> {
    this._updateProfiles(update);
    await this._checkPlayers(update);
  }

  async onExit(_update: GameUpdate): Promise<void> {
    this._clearBettingActivity();
  }
}
